<div *ngIf="params && params['data']">
  <span *ngIf="params.data.agreement">{{ params.data.agreement.name }}</span>
  <span *ngIf="!params.data.agreement">-</span>
</div>
